import { produce, Draft } from 'immer'
import { TActionTypes } from '@Root/types'

import {
  IAuthenticationState,
  AuthenticationActionTypes,
} from './types'

export const initialState: IAuthenticationState = {
  loading: false
}

type TAction = TActionTypes

export const authenticationReducer = (
  state: IAuthenticationState = initialState,
  action: TAction
): IAuthenticationState => {
  return produce(state, draft => {
    switch (action.type) {
      case AuthenticationActionTypes.SIGN_UP:
      case AuthenticationActionTypes.SIGN_IN:
      case AuthenticationActionTypes.PASSWORD_NEW:
      case AuthenticationActionTypes.UPDATE_PASSWORD:
        setLoading(draft)
        break

      case AuthenticationActionTypes.SIGN_UP_SUCCESS:
      case AuthenticationActionTypes.SIGN_UP_FAILURE:
      case AuthenticationActionTypes.SIGN_IN_SUCCESS:
      case AuthenticationActionTypes.SIGN_IN_FAILURE:
      case AuthenticationActionTypes.PASSWORD_NEW_SUCCESS:
      case AuthenticationActionTypes.PASSWORD_NEW_FAILURE:
      case AuthenticationActionTypes.UPDATE_PASSWORD_SUCCESS:
      case AuthenticationActionTypes.UPDATE_PASSWORD_FAILURE:
        resetLoading(draft)
        break

      default:
        break
    }
  })
}

const setLoading = (draft: Draft<IAuthenticationState>) => {
  draft.loading = true
}

const resetLoading = (draft: Draft<IAuthenticationState>) => {
  draft.loading = false
}
